<template>
  <div>
    <b-modal ref="editsitemodal" class="editsitemodal" centered :lazy="true" title="Edit Site Details" ok-title="Save changes" @ok="saveChanges()" @shown="loadInitialData" :hide-header-close="true" :hide-footer="true">
      <b-tabs pills card vertical v-model="tabIndex">
        <b-tab v-for="(menu,$index) in menus" :title="menu.name" :key="$index">
          <component v-if="tabIndex==$index" :is="menu.component" v-model="currentSite"></component>
        </b-tab>

      </b-tabs>
      <div class="w-100 modal-footer">
        <div class="text-right">
          <b-btn variant="flat" @click="close()">
            Cancel
          </b-btn>
          <b-btn variant="primary" @click="saveChanges()">
            Save Changes
          </b-btn>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import WpAdminDetails from '../Common/WpAdminDetails';
import AssignGroups from '../Common/AssignGroups';
import FolderProtection from '../Common/FolderProtection';
import Advanced from '../Common/Advanced';
import SiteAlias from '../Common/SiteAlias';
import FTPDetails from '../Common/FTPDetails';

import Utils from '../../mixins/utils';
export default {
  name: 'editsite',
  props: ['site'],
  components: {
    WpAdminDetails,
    AssignGroups,
    FolderProtection,
    Advanced,
    SiteAlias,
    FTPDetails
  },
  mounted() {},
  mixins: [Utils],
  data() {
    return {
      currentSite: {},
      tabIndex: 0,
      menus: [
        {
          name: 'WP Admin Details',
          component: 'wp-admin-details'
        },
        {
          name: 'Assign Groups',
          component: 'assign-groups'
        },
        {
          name: 'Folder Protection',
          component: 'folder-protection'
        },
        {
          name: 'Advanced',
          component: 'advanced'
        },
        {
          name: 'Site Alias',
          component: 'site-alias'
        },
        {
          name: 'FTP Details',
          component: 'f-t-p-details'
        }
      ]
    };
  },
  methods: {
    loadInitialData() {
      this.currentSite = _.cloneDeep(this.site);

      this.tabIndex = 0;
    },
    saveChanges() {
      let payload = {};
      let requiredData = {};

      requiredData['updateSite'] = {
        URL_b64encoded: btoa(this.currentSite.URL),
        siteID: this.currentSite.siteID,
        adminURL_b64encoded: btoa(this.currentSite.adminURL),
        groupIDs: this.currentSite.groupIDs,
        adminUsername: this.currentSite.adminUsername,
        connectURL: this.currentSite.connectURL,
        callOpt: this.currentSite.callOpt,
        siteName: this.currentSite.name,
        httpAuth: this.currentSite.httpAuth
      };
      requiredData['saveSiteFtpDetails'] = {
        hostName: this.currentSite.ftpDetails.hostName,
        hostPort: this.currentSite.ftpDetails.hostPort,
        hostUserName: this.currentSite.ftpDetails.hostUserName,
        hostPassword: this.currentSite.ftpDetails.hostPassword,
        remoteFolder: this.currentSite.ftpDetails.remoteFolder,
        newSiteURL: this.currentSite.ftpDetails.newSiteURL,
        hostPassive: this.currentSite.ftpDetails.hostPassive,
        hostSSL: this.currentSite.ftpDetails.use_ftpssl,
        use_ftp: this.currentSite.ftpDetails.use_ftp,
        use_sftp: this.currentSite.ftpDetails.use_sftp,
        siteID: this.currentSite.siteID,
        sourceSiteID: this.currentSite.siteID,
        toIWP: 1
      };
      requiredData.getSitesUpdatesV3 = 1;
      requiredData.getClientUpdateAvailableSiteIDs = 1;
      requiredData.getGroupsSitesV3 = 1;
      requiredData.getSites = 1;
      requiredData.getPluginsAndThemesV3 = 1;

      payload.requiredData = requiredData;
      this.$store.dispatch('sendAction', payload).then(response => {
        let actionData = response.data;
        _.forEach(actionData, (actionDataItem, actionDataKey) => {
          let mutationKey = this.getMutationBasedOnKey(actionDataKey);
          if (mutationKey) {
            this.$store.commit(mutationKey, actionDataItem);
          }
        });
        this.close();
      });
    },
    close() {
      this.$refs.editsitemodal.hide();
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/modals/EditSite.vue